import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'plm-parameters',
  templateUrl: './parameters.component.html',
  styleUrls: ['./parameters.component.css']
})
export class ParametersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
